import { callApi } from '@local_modules/generic/fetch'

export async function loadAllEntities () {
  const apiUrl = '/api/app-account-organisation/list-all'
  const data = await callApi(apiUrl)
  // console.log('api data', data)

  return data
}
